import React from "react";
import DebatIslam from "../components/debateIslam.component";
import ArticleSection from "../components/latestArticle.component";
import LatestCommentsSection from "../components/latestComments.component";
import PopularArtilces from "../components/popularArticles.component";
import SubscribeSection from "../components/subscribe.component";
import VideoSection from "../components/videoSection.component";
import http from "../http";

class Home extends React.Component {
  state = {
    writers: [],
    bestOfBeforeArticles: [],
    sections: [],
    latestAricles: [],
    latestComments: [],
    mostPopularArticles: [],
    documentsData: [],
    latestVideos: [],
  };
  componentDidMount() {
    this.getBestBeforeArticles();
    this.getLatestArticles();
    this.getLatestComments();
    this.getSectionsData();
    this.getMostPopularArticles();
    this.getBooksAndDocuments();
    this.getLatestVideos();
  }
  getBestBeforeArticles = async () => {
    try {
      const result = await http.get("/getBestOfBeforeArtilces", {
        params: { view: "home" },
      });
      this.setState({
        bestOfBeforeArticles: [
          {
            data: result.data.results,
            comments: result.data.comments,
          },
        ],
      });
    } catch (err) {
      console.log(err);
    }
  };

  getSectionsData = async () => {
    try {
      const sections = localStorage.getItem("sections");
      const tx = localStorage.getItem("sectionsTime");
      const tc = new Date().getTime();
      const diff = Math.abs((parseInt(tc) - parseInt(tx)) / (60 * 60 * 1000));
      if (sections && diff < 8) {
        this.setState({ sections: JSON.parse(sections) });
        return;
      }
      const result = await http.get("/sections");
      localStorage.setItem("sections", JSON.stringify(result.data));
      localStorage.setItem("sectionsTime", new Date().getTime());
      this.setState({
        sections: result.data,
      });
    } catch (err) {
      console.log(err);
    }
  };

  getLatestArticles = async () => {
    try {
      const result = await http.get("/latestArticles", {
        params: { view: "home" },
      });
      this.setState({
        latestAricles: [
          {
            data: result.data.results,
            comments: result.data.comments,
          },
        ],
      });
    } catch (err) {
      console.log(err);
    }
  };

  getLatestComments = async () => {
    try {
      const result = await http.get("/latestComments", {
        params: { view: "home" },
      });
      this.setState({
        latestComments: result.data.results,
      });
    } catch (err) {
      console.log(err);
    }
  };

  getMostPopularArticles = async () => {
    try {
      const result = await http.get("/getMostPopularArticles", {
        params: { view: "home" },
      });
      this.setState({
        mostPopularArticles: [
          {
            data: result.data.results,
            comments: result.data.comments,
          },
        ],
      });
    } catch (err) {
      console.log(err);
    }
  };

  getSectionByFilter = (filter) => {
    const { sections } = this.state;
    if (!sections.length) {
      return sections;
    }

    return sections.filter((section) => {
      return filter
        ? section.Group_Name.includes("Section")
        : !section.Group_Name.includes("Section");
    });
  };

  getLatestVideos = async () => {
    try {
      const result = await http.get("/getVideos", {
        params: { view: "home" },
      });
      this.setState({
        latestVideos: result.data.results,
      });
    } catch (err) {
      console.log(err);
    }
  };

  getBooksAndDocuments = async () => {
    try {
      const result = await http.get("/getMostPopularBooksAndDocuments");
      this.setState({
        documentsData: [
          {
            data: result.data.results,
            comments: result.data.comments,
          },
        ],
      });
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    let {
      latestAricles,
      latestComments,
      mostPopularArticles,
      documentsData,
      bestOfBeforeArticles,
    } = this.state;
    return (
      <React.Fragment>
        <DebatIslam
          articles={
            bestOfBeforeArticles.length ? bestOfBeforeArticles[0]["data"] : []
          }
          comments={
            bestOfBeforeArticles.length
              ? bestOfBeforeArticles[0]["comments"]
              : []
          }
        />
        <ArticleSection
          latestAricles={latestAricles.length ? latestAricles[0]["data"] : []}
          comments={latestAricles.length ? latestAricles[0]["comments"] : []}
        />
        <VideoSection
          languageData={this.getSectionByFilter(true)}
          sectionsData={this.getSectionByFilter(false)}
        />
        <SubscribeSection />
        <LatestCommentsSection
          latestComments={latestComments.slice(0, 6)}
          latestVideos={this.state.latestVideos}
        />
        <PopularArtilces
          mostPopularArticles={
            mostPopularArticles.length ? mostPopularArticles[0]["data"] : []
          }
          popularComments={
            mostPopularArticles.length ? mostPopularArticles[0]["comments"] : []
          }
          documentsData={documentsData.length ? documentsData[0]["data"] : []}
          documentsComments={
            documentsData.length ? documentsData[0]["comments"] : []
          }
        />
      </React.Fragment>
    );
  }
}

export default Home;
